<template>
  <auth-layout :page="'forgot'">
    <h1 class="text-xl mb-2 text-bold">
      <span v-if="!success">Almost there...</span>
      <span v-if="success">Done!</span>
    </h1>

    <p class="text-xs mb-6" v-if="!success">Reset your password below.</p>

    <div>
      <div v-if="success" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4" role="alert">
        {{success}}
      </div>

      <div v-if="error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert" v-html="error">
      </div>

      <div v-if="success">
        <div class="mb-6">
          <router-link class="no-underline align-baseline font-medium text-xs" style="font-size: 12px; margin-top:16px;" to="/login">Back to login</router-link>
        </div>
      </div>

      <div v-else>

        <div class="mb-4">
          <p class="mb-1 text-xs mb-2">New Password</p>
          
          <input type="password" ref="password" class="rg-text-field rg-auth-field block w-full border-0 px-2 py-2 rounded" placeholder="Enter new password" :class="{'opacity-50 cursor-not-allowed': submitting}">
        </div>

        <div class="mb-4">
          <p class="mb-1 text-xs mb-2">Confirm Password</p>

          <input type="password" ref="password_confirmation" class="rg-text-field rg-auth-field block w-full border-0 px-2 py-2 rounded" placeholder="Re-Enter new password" :class="{'opacity-50 cursor-not-allowed': submitting}">
        </div>


        <div class="">

            <button class="w-full rounded bg-blue text-white text-bold text-xs focus:outline-none py-3 px-4" :class="{'spinner': submitting}" @click="submit">
                RESET PASSWORD
            </button>

        </div>
      </div>

    </div>

  </auth-layout>

</template>

<script>

import axios from 'axios'
import AuthLayout from '@/components/AuthLayout.vue'

export default {
  components: {
    AuthLayout
  },

  data: function() {
    return {
      success: null,
      info: null,
      error: null,
      submitting: false
    }
  },
  metaInfo () {
    return {
      title: "Reset Password | " + this.$appName
    }
  },
  methods: {
    async validateToken() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/users/validate-reset-token/${this.$route.params.token}`)
        
        if (!response.data.success) {
          this.error = "This reset link is invalid or has expired. Please request a new password reset."
        }
      } catch (e) {
        this.error = "This reset link is invalid or has expired. Please request a new password reset."
      }
    },
    
    async submit() {
      let self = this
      this.submitting = true
      this.error = null
      this.success = null

      // Validate passwords match
      const password = self.$refs.password.value.trim()
      const passwordConfirmation = self.$refs.password_confirmation.value.trim()
      
      if (!password || !passwordConfirmation) {
        this.error = "Please enter and confirm your new password"
        this.submitting = false
        return
      }
      
      if (password !== passwordConfirmation) {
        this.error = "Passwords do not match"
        this.submitting = false
        return
      }
      
      if (password.length < 6) {
        this.error = "Password must be at least 6 characters long"
        this.submitting = false
        return
      }

      try {
        const response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/users/reset-password`, {
          token: self.$route.params.token,
          password: password
        })

        if (response.data.success) {
          this.success = "Your password has been reset successfully. You can now login with your new password."
        } else {
          this.error = response.data.message || "Failed to reset password. Please try again."
        }

      } catch(error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.error = error.response.data.message
        } else {
          this.error = "An error occurred while resetting password. Please try again."
        }
      }

      this.submitting = false
    }
  },
  mounted() {
    // Validate token when component loads
    this.validateToken()
    
    try {
      this.$refs.password.focus()
    }
    catch (e) {}
  }
};
</script>